// extracted by mini-css-extract-plugin
export var actionIcon = "_o4-0";